/*
 * File: /src/store/modules/templates.js
 * Created Date: Sunday April 7th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 7th April 2019 7:26:50 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

import { authedAxios } from '../../shared/axiosWrapper';
import airbnbTemplateService from '../../services/airbnbTemplateService';
import templateService from '../../services/templateServices';
import emailTemplateService from '../../services/emailTemplateServices';

const templateTypes = [
  'sms',
  'popup',
  'postcard',
];

const state = {
  templates: {
    airbnb: undefined,
    email: undefined,
    // emailReply: undefined,
    sms: undefined,
    popup: undefined,
    // Whats app is a differnt lightweight format
    whatsapp: undefined,
  },
};

const getters = {
  getAirbnbTemplates: (state) => {
    return state.templates.airbnb;
  },
  getEmailTemplates: (state) => {
    return state.templates.email;
  },
  getEmailReplyTemplates: (state) => {
    return state.templates.email ? state.templates.email.filter(f => f.is_reply == true) : [];
  },
  getSmsTemplates: (state) => {
    return state.templates.sms;
  },
  getSmsReplyTemplates: (state) => {
    return state.templates.sms ? state.templates.sms.filter(t => t.is_reply) : [];
  },
  getPopupTemplates: (state) => {
    return state.templates.popup;
  },
  getWhatsappTemplates: (state) => {
    return state.templates.whatsapp;
  },
  getTemplate: (state) => (id) => {
    for (const type of templateTypes) {
      if (state.templates[type] == undefined) {
        console.log('getTemplate called before store was fetched');
        return undefined;
      };
      for (const t of state.templates[type]) {
        if (t.id === id) {
          return t;
        }
      }
    }
  },
};
const actions = {
  unloadTemplates({ commit }) {
    commit('clearTemplates', '');
  },
  async fetchTemplates({ commit, state }) {
    // Will be undefined on init only
    if (state.templates.email) {
      return;
    }
    const templates = {
      airbnb: [],
      email: [],
      sms: [],
      popup: [],
      // emailReply: [],
      // smsReply: [],
      whatsapp: [],
    };
    const promises = [];
    for (const type of templateTypes) {
      promises.push(
        templateService.fetchTemplates(false, type).then((t) => {
          t.data.forEach((template) => {
            templates[type].push(template);
          });
        })
      );
    }
    promises.push(
      emailTemplateService.fetchTemplates().then((t) => {
        t.data.forEach((template) => {
          templates['email'].push(template);
        });
      })
    );
    /*
     * TODO: we can store just the reply templates in memory for the app
     * since those are use in the inbox/email/etc.
     * The rest we can load on demand when needed.
     * Currently in call plans, automations.
    promises.push(
      emailTemplateService.fetchReplyTemplates().then((t) => {
        t.data.forEach((template) => {
          templates['email'].push(template);
        });
      })
    );
    */
    promises.push(
      templateService.fetchWhatappTemplates().then((t) => {
        t.data.forEach((template) => {
          templates['whatsapp'].push(template);
        });
      })
    );
    promises.push(
      airbnbTemplateService.fetchTemplates().then((t) => {
        t.data.forEach((template) => {
          templates['airbnb'].push(template);
        });
      })
    );
    await Promise.all(promises);
    commit('addTemplates', templates);
  },

  async addTemplate({ commit }, template) {
    // TODO: Save template from template service?
    return authedAxios.post('/v1/templates', template).then((r) => {
      commit('addTemplate', r.data);
    });
  },
};
const mutations = {
  clearTemplates(state) {
    state.templates = {
      email: undefined,
      sms: undefined,
      popup: undefined,
    };
  },
  addTemplates(state, templateData) {
    // cast a new object on it
    state.templates = Object.assign({}, templateData);
  },
  addTemplate(state, templateData) {
    if (!templateData.type || !templateData.id) {
      return;
    }
    state.templates[templateData.type][templateData.id] = templateData;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
